<template>
  <div
    ref="ace"
    class="ace-editor"
    :style="{ width, height }"
  />
</template>

<script>
import ace from 'ace-builds';
import 'ace-builds/webpack-resolver'; // 在 webpack 环境中使用必须要导入
import 'ace-builds/src-noconflict/theme-chrome'; // 默认设置的主题
import 'ace-builds/src-noconflict/mode-json'; // 默认设置的语言模式
import beautify from 'ace-builds/src-noconflict/ext-beautify';

export default {
  name: 'JsonEditor',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: () => '{}',
      required: true,
    },
    width: {
      type: String,
      default: '500px',
    },
    height: {
      type: String,
      default: '300px',
    },
    tabSize: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      aceEditor: null,
      themePath: 'ace/theme/chrome', // 不导入 webpack-resolver，该模块路径会报错
      modePath: 'ace/mode/json', // 同上
    };
  },
  watch: {
    value: {
      handler(value) {
        this.setEditorValue(value);
      },
    },
  },
  mounted() {
    // 初始化ACE编辑器, 根据props的动态内容通过api设置, 不要在edit里面初始化
    this.$nextTick(() => {
      try {
        this.aceEditor = ace.edit(this.$refs.ace, {
          fontSize: 14, // 编辑器内字体大小
          theme: this.themePath, // 默认设置的主题
          mode: this.modePath, // 默认设置的语言模式
          tabSize: this.tabSize, // 制表符设置为 4 个空格大小
        });
        this.setEditorValue(this.value);
        this.aceEditor.on(
          'change',
          () => {
            this.$emit('change', this.aceEditor.getValue());
          },
        );
      } catch (e) {
        console.error('show editor error', e);
      }
    });
  },
  methods: {
    setEditorValue(value) {
      if (this.aceEditor) {
        this.aceEditor.setValue(value ? JSON.stringify(JSON.parse(value), null, this.tabSize) : '{}'); // 设置值
        beautify?.beautify(this.aceEditor.session);
      }
    },
  },
};
</script>

<style lang="less">
.ace-editor {
  width: 100%;
  height: 300px;
}
</style>
